import React, { FC } from "react";

export type Props = {
  checked: boolean;
  onChange: (newVal: boolean) => void; // nebo implicitně () => void
};

const Checkbox: FC<Props> = ({ checked, onChange }) => (
  <input
    data-cy="checkbox"
    type="checkbox"
    checked={checked}
    onChange={(e) => onChange(Boolean(e.target.value))}
    enterKeyHint="done"
  />
);

export default Checkbox;
export type CheckboxProps = Props;
